import { render } from "./organizationRole.vue?vue&type=template&id=246d75a0&scoped=true"
import script from "./organizationRole.vue?vue&type=script&lang=js"
export * from "./organizationRole.vue?vue&type=script&lang=js"

import "./organizationRole.vue?vue&type=style&index=0&id=246d75a0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-246d75a0"]])

export default __exports__